import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=960287cc&scoped=true"
import script from "./CompanySelector.vue?vue&type=script&lang=js"
export * from "./CompanySelector.vue?vue&type=script&lang=js"
import style0 from "./CompanySelector.vue?vue&type=style&index=0&id=960287cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960287cc",
  null
  
)

export default component.exports